module.exports = __webpack_public_path__ + "static/assets/4f86a86991186fc622c31cf373e0b9d8.png";